module.exports = __webpack_public_path__ + "img/img39.8a4a35ed.svg";